import moment from 'moment'

const getRaceDayAge = ({ race, birthDate }) => {
  // console.log({ race, birthDate })
  return moment(race.startTime).diff(moment(birthDate), 'years')
}

export default getRaceDayAge



// WEBPACK FOOTER //
// ./src/App/utils/getRaceDayAge.js